/*
 * Copyright (c) 2020 - 2025 Ping Identity Corporation. All rights reserved.
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file for details.
 */
import { BaseCallback } from './base-callback.js';
/**
 * Represents a callback used to collect acceptance of terms and conditions.
 */
export class TermsAndConditionsCallback extends BaseCallback {
    payload;
    /**
     * @param payload The raw payload returned by OpenAM
     */
    constructor(payload) {
        super(payload);
        this.payload = payload;
    }
    /**
     * Gets the terms and conditions content.
     */
    getTerms() {
        return this.getOutputByName('terms', '');
    }
    /**
     * Gets the version of the terms and conditions.
     */
    getVersion() {
        return this.getOutputByName('version', '');
    }
    /**
     * Gets the date of the terms and conditions.
     */
    getCreateDate() {
        const data = this.getOutputByName('createDate', '');
        const date = new Date(data);
        return Number.isNaN(date.getTime()) ? null : date;
    }
    /**
     * Sets the callback's acceptance.
     */
    setAccepted(accepted = true) {
        this.setInputValue(accepted);
    }
}
